import {SET_MAP_ADDRESS} from './types';

const setMapAddress = address => ({
  type: SET_MAP_ADDRESS,
  address,
});

export default setMapAddress;
